import styled from "styled-components";
import Theme from "../../../styles/Theme";

export const ChatPreviewWrapper = styled.div`
  width: 100%;
  padding: 12px;
  background-color: ${Theme.COLORS.BACKGROUND};
  color: ${Theme.COLORS.ON_BACKGROUND};
`;
